import { render, staticRenderFns } from "./ChordFingering.vue?vue&type=template&id=5da57805&scoped=true&"
import script from "./ChordFingering.vue?vue&type=script&lang=js&"
export * from "./ChordFingering.vue?vue&type=script&lang=js&"
import style0 from "./ChordFingering.vue?vue&type=style&index=0&id=5da57805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da57805",
  null
  
)

export default component.exports